import * as React from "react";
import styled from "@mui/material/styles/styled";
import { GenderValue } from "shared";
import { ThemeImage } from "fe-web-components/themeImage/themeImage";
import { ReactComponent as GenericFemaleIcon } from "../assets/femaleIconGeneric.svg";
import { ReactComponent as GenericMaleIcon } from "../assets/maleIconGeneric.svg";
import clsx from "clsx";
import { ThemeSettings } from "@kahunmedical/common-configuration";
import { CommonColors } from "../colors/commonColors";

//region [[ Styles ]]
const GenderIconView = styled("div")({});

const GenderIconContainer = styled("div")(() => ({
  "& img": {
    height: "43px",
    width: "43px",
    borderRadius: "50%",
  },
  "& svg": {
    height: "43px",
    width: "43px",
  },
  "&.small img": {
    height: "30px",
    width: "30px",
  },
  "&.small svg": {
    height: "30px",
    width: "30px",
  },
  "&.big img": {
    height: "54px",
    width: "54px",
  },
  "&.big svg": {
    height: "54px",
    width: "54px",
  },
  paddingLeft: "5px",
  paddingRight: "5px",
  display: "flex",
  justifyContent: "center",
  "& circle": {
    fill: CommonColors.Selected,
  },
}));
//endregion [[ Styles ]]

//region [[ Props ]]
interface GenderIconProps {
  gender: GenderValue;
  themeSettings: ThemeSettings;
  small?: boolean;
  big?: boolean;
}
//endregion [[ Props ]]

//region [[ Functions ]]

//endregion [[ Functions ]]

const GenderIcon = ({ gender, themeSettings, small, big }: GenderIconProps) => {
  if (!gender) return null;

  return (
    <GenderIconView className={"gender-icon-view"}>
      {gender === GenderValue.MALE || (gender as string) === "Male" ? (
        <GenderIconContainer
          className={clsx(
            "gender-icon-container",
            small ? "small" : "",
            big ? "big" : "",
          )}
        >
          {!!themeSettings?.maleIcon && (
            <ThemeImage source={themeSettings.maleIcon} />
          )}
          {!themeSettings?.maleIcon && <GenericMaleIcon />}
        </GenderIconContainer>
      ) : (
        <GenderIconContainer
          className={clsx(
            "gender-icon-container",
            small ? "small" : "",
            big ? "big" : "",
          )}
        >
          {!!themeSettings?.femaleIcon && (
            <ThemeImage source={themeSettings.femaleIcon} />
          )}
          {!themeSettings?.femaleIcon && <GenericFemaleIcon />}
        </GenderIconContainer>
      )}
    </GenderIconView>
  );
};

export default GenderIcon;
